// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const CLOSE_WINDOW = "Zavri";
export const LIKE = "P\u00e1\u010di sa mi to";
export const YOU_DONT_HAVE_RIGHTS_TO_SEE_WHO_LIKED_THIS_COMMENT = "Nem\u00f4\u017ee\u0161 vidie\u0165, komu sa p\u00e1\u010di tento koment\u00e1r";
export const YOU_DONT_HAVE_RIGHTS_TO_SEE_WHO_LIKED_THIS_POST = "Nem\u00f4\u017ee\u0161 vidie\u0165, komu sa p\u00e1\u010di tento pr\u00edspevok";
